<nz-modal nzTitle="Deposit Records" [(nzVisible)]="modalVisible.listing" nzWidth="600px" [nzMaskClosable]="false"
  (nzOnCancel)="modalVisible.listing = false" (nzOnOk)="modalVisible.listing = false" nzWrapClassName="deposit-modal">
  <ng-container *nzModalContent>
    @if (editable) {
    <div class="modal-toolbar">
      <button type="button" nz-button nzType="primary" (click)="openDetail()">Add</button>
    </div>
    }
    <nz-table [nzData]="records.length > 0? [{ placeholder: true }]: []" [nzBordered]="true" [nzSize]="'small'"
      [nzLoading]="loading">
      <thead>
        <tr>
          <th nzWidth="150px">Date</th>
          <th>Receipt#</th>
          <th>Reference No</th>
          <th>Amount</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for(record of records; track i; let i = $index){
        <tr>
          <td>{{record.docDate | date: dateFormatService.currentDateFormatValue }}</td>
          <td>
            <a (click)="openDetail(record)">
              @if (record.docCode) {
              {{record.docCode}}
              } @else {
              <nz-tag nzColor="orange" nzSize="small">Unsaved</nz-tag>
              }
            </a>
          </td>
          <td>{{record.referenceNo}}</td>
          <td>{{record.totalAmount | currency: ' ' }}</td>
          <td>
            @if (record.tempId && !record.id) {
            <a nz-popconfirm nzPopconfirmTitle="Are you sure to remove this item?"
              (nzOnConfirm)="removeDeposit(record.tempId)">
              <span nz-icon nzType="delete" nzTheme="outline"></span>
            </a>
            }
            @else {
            <button type="button" nz-button nzType="link" (click)="navigateToDeposit(record.id)">
              <span nz-icon nzType="eye" nzTheme="outline"></span>
            </button>
            }
          </td>
        </tr>
        }
      </tbody>
    </nz-table>
  </ng-container>
</nz-modal>


<nz-modal nzTitle="Create Deposit Payment" [(nzVisible)]="modalVisible.entry" [nzMaskClosable]="false"
  (nzOnCancel)="modalVisible.entry = false" (nzOnOk)="addDeposit()">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="depositForm" nzLayout="vertical">
      <!-- Date -->
      <nz-row nzGutter="8">
        <nz-col nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="docDate">Date</nz-form-label>
            <nz-form-control nzErrorTip="Transaction Date is required">
              <app-date-input formControlName="docDate" required [nzAllowClear]="false">
              </app-date-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-row nzGutter="8">
         <!-- Deposit To-->
         <nz-col nzMd="12" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="account" nzRequired>Deposit To</nz-form-label>
            <nz-form-control nzErrorTip="Deposit account is required">
              <app-cac-select formControlName="account" [required]="true" [allowClear]="false" labelType="name"
                defaultType="deposit"></app-cac-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <!-- Reference No -->
        <nz-col nzMd="12" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="refNo">Ref No.</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="referenceNo" maxlength="50"></app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-row nzGutter="8">
        <!-- Currency -->
        <nz-col nzMd="12" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="currencyRate">Currency Rate</nz-form-label>
            <nz-form-control nzErrorTip="Currency rate is required">
              <app-currency-rate formControlName="currencyRate" required="true"
                [currency]="depositForm.controls.currency.value">
              </app-currency-rate>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <!-- Bank Charges -->
        <nz-col nzMd="12" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="bankChargesAmountLocal">Bank Charges (Local Amt.)</nz-form-label>
            <nz-form-control>
              <nz-input-group nzCompact>
                <app-currency-input formControlName="bankChargesAmountLocal">
                </app-currency-input>
                <button type="button" nz-button nzType="default" [disabled]="!editable" (click)="bankChargesModal()">
                  <span nz-icon nzType="ellipsis"></span>
                </button>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-row nzGutter="8">
        <!-- Reference No -->
        <nz-col nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="account">Payment</nz-form-label>
            <nz-form-control nzErrorTip="Deposit account is required">
              <app-currency-input formControlName="totalAmount">
              </app-currency-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-row nzGutter="8">
        <!-- Description -->
        <nz-col nzMd="24" nzSm="24" nzXs="24">
          <nz-form-item>
            <nz-form-label nzFor="description">Description</nz-form-label>
            <nz-form-control>
              <app-text-input formControlName="description" maxlength="250" [tabIndex]="9"></app-text-input>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </form>
  </ng-container>
</nz-modal>